module.exports = {"labels":{"identifiersQuantity":"QUANTAS VELOETAGS VOCÊ QUER?"},"errorMessages":{"emptyField":"Campo obrigatório"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/IdentifierQuantityForm/data.json
// module id = 2030
// module chunks = 0